// extracted by mini-css-extract-plugin
export var counter = "counter-module--counter--44084";
export var fadeInAnimation = "counter-module--fadeInAnimation--4f7b7";
export var hint = "counter-module--hint--7ef4f";
export var item = "counter-module--item--6a7ad";
export var itemTitle = "counter-module--itemTitle--ae780";
export var list = "counter-module--list--dc66b";
export var tag = "counter-module--tag--edeac";
export var title = "counter-module--title--81033";